/**
 * 积分不足的消息
 */
import { Button } from 'antd';
import CheckedIcon from '/public/checked.svg';
import PointsIcon from '/public/point.svg';
import React, { useEffect, useState } from 'react';
import { useSpacePointsContext } from '@/contexts/space-points-context';
import { getGetMorePointsCustomerConfig } from '@/constants/tip-config';
import { triggerCustomerModal } from '../antd-wrapper/modal/contact/customer-manager';
import ErrorIcon from '/public/error.svg';
import { useI18n } from '@/hooks/use-i18n';

interface NoPointsMsgProps {
  onContinue: () => Promise<void>;
}

const NoPointsMsg: React.FC<NoPointsMsgProps> = ({ onContinue }) => {
  const { t } = useI18n(['components', 'common']);
  const { spacePoints, refetch } = useSpacePointsContext();
  const [isLoading, setIsLoading] = useState(false);

  const getPoint = () => {
    const config = getGetMorePointsCustomerConfig();
    triggerCustomerModal({
      title: config.title,
      data: config.data,
    });
  };

  // 挂载的时候刷新下积分，因为 event 的是有延时的
  useEffect(() => {
    refetch();
  }, []);

  const handleContinue = async () => {
    setIsLoading(true);
    try {
      await onContinue();
    } finally {
      setIsLoading(false);
    }
  };

  if (spacePoints?.balance) {
    return (
      <div className="flex items-center justify-between bg-[#7171EE33] rounded-[8px] h-10 px-3">
        <span className="flex items-center gap-2">
          <CheckedIcon className="w-4 h-4" />
          <span className="text-primary font-semibold text-[14px]">
            {t('components:points.pointsRefreshed')}
          </span>
        </span>
        <Button
          size="small"
          shape="round"
          loading={isLoading}
          onClick={handleContinue}
          className="!px-[5px] !text-primary !text-[13px] !border-primary"
        >
          {t('common:continueExecution')}
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between bg-[#F4F4F5] border border-[#E5E5E5] h-10 px-3 rounded-[8px]">
      <span className="flex items-center gap-2">
        <ErrorIcon className="w-4 h-4" />
        <span className="text-[#000000BF] font-semibold text-[14px]">
          {t('components:points.insufficientPoints')}
        </span>
      </span>
      <span
        className="flex items-center gap-1 cursor-pointer"
        onClick={getPoint}
      >
        <PointsIcon className="w-4 h-4" />
        <span className="text-primary text-[13px] font-semibold">
          {t('common:getPoints')}
        </span>
      </span>
    </div>
  );
};

export default NoPointsMsg;
